<template>
	<!-- Activity timeline component, to display delivery logs -->
	<div class="XXXcard">
		<div class="card-body">
			<button
				v-if="!hideCloseBtn"
				class="btn btn-outline-primary float-right"
				@click="onClick(id)"
			>
				<i class="mdi mdi-close" />
				{{ $t('Common.button_close') }}
			</button>
			<h4 class="header-title mb-2">{{ title }}</h4>

			<div class="timeline-alt pb-0">
				<div
					v-for="activity of activityData"
					:key="activity.id"
					:class="`timeline-item background-${activity.backgroundColor}`"
				>
					<i
						:class="`mdi ${activity.icon} bg-${activity.color}-lighten text-${activity.color} timeline-icon`"
					/>
					<div class="timeline-item-info">
						<div
							href="#"
							:class="`text-${activity.color} font-weight-bold mb-1 d-block`"
						>
							{{ activity.title }}
						</div>
						<p class="mb-0 pb-0">
							<small class="font-weight-bold">
								{{ activity.subtitle }}
							</small>
						</p>
						<div v-if="activity.remarkText">
							<small>
								{{ activity.remarkText }}
							</small>
						</div>
						<small>
							{{ activity.text }}
							<span class="font-weight-bold">
								{{ activity.boldText }}
							</span>
						</small>
						<p class="mb-0 pb-2">
							<small class="text-muted">
								{{ activity.subtext }}
								<span class="font-weight-bold">
									{{ activity.boldSubtext }}
								</span>
							</small>
						</p>
						<div
							v-if="activity.proofsOfDelivery"
							class="proof-of-delivery"
						>
							<img
								v-for="proof in activity.proofsOfDelivery"
								:key="proof"
								v-lazy="proof"
								@click="openImagTab(proof)"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		id: {
			type: Number,
			default: 0
		},
		title: {
			type: String,
			default: 'Activity'
		},
		activityData: {
			type: Array,
			default: () => []
		},
		onClick: {
			type: Function,
			default: () => {}
		},
		hideCloseBtn: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		openImagTab(url) {
			window.open(url)
		}
	}
}
</script>

<style lang="scss" scoped>
.proof-of-delivery {
	display: flex;
	flex-wrap: wrap;

	img {
		width: 200px;
		height: 200px;
		object-fit: cover;
		cursor: pointer;
		margin: 0 10px 10px 0;
		border: 1px solid #ccc;

		&[lazy='loading'] {
			background: #eee;
			border-color: transparent;
		}
	}
}
</style>
